module.exports = __webpack_public_path__ + "img/composite_bg.4d1d58e2.png";